<template>
  <q-page-container>    
    <q-page>
      <div class="header">
        <q-btn rounded unelevated color="red-9" @click="loagoutUser">
          Sair
        </q-btn>
        <section
          class="q-pt-lg section-header-description flex row justify-between"
        >
          <label>Meu histórico</label>
          <span class="text-red"
            >Proxima atualização em: {{ temporizationRefresh }}</span
          >
        </section>
        <q-separator color="#C6C6C6" size="2px" spaced="md" />
        <section class="col-12 row section-search q-pt-sm">
          <div class="col-12 row">
            <div class="col-12 row">
              <q-input
                class="col-12"
                bg-color="white"
                v-model="search"
                type="search"
                outlined
                color="red-9"
                placeholder="Pesquisar"
                dense="dense"
                @keyup="filterServiceHistory"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </div>
        </section>
      </div>
      <div class="content-cards-histories">
        <div
      v-if="isLoadingHistory"
      class="col-12 full-height full-width flex justify-center items-center"
    >
      <q-circular-progress
        indeterminate
        rounded
        size="60px"
        color="red"
        class="q-ma-md"
      />
      </div>
        <section v-else class="col-12 row section-cards-histories">
          <div class="col-12 row">
            <router-link
              :to="{
                name: 'view-datails-contract-os',
                params: { contract_number: item.contractNumber },
              }"
              class="col-12 row flex justify-center"
              v-for="item in FilterServiceHistoryList"
              :key="item.contractNumber"
            >
              <CardServiceHistory :data="item" />
            </router-link>
          </div>
        </section>
      </div>
    </q-page>
  </q-page-container>

  <q-page-sticky position="bottom-right" :offset="[18, 18]">
    <router-link :to="{ name: 'type-service' }">
      <q-btn fab icon="add" color="red-9" />
    </router-link>
  </q-page-sticky>
</template>

<script>
import AuthService from "@/services/AuthService.js";
import ServiceHistoryServices from "../services/ServiceHistoryServices";

import CardServiceHistory from "@/components/CardServiceHistory";
import createJsonAccess from "@/utils/auth/authUserData.js";
import jwt_decode from "jwt-decode";

export default {
  name: "ServiceHistory",
  created() {
    this.serviceHistoryServices = new ServiceHistoryServices();
    this.authService = new AuthService();
  },
  components: {
    CardServiceHistory,
  },
  computed: {
    FilterServiceHistoryList() {
      if (this.search === "") {
        return this.serviceHistoryList;
      } else {
        return this.serviceHistoryList.filter((element) => {
          if (element.contractNumber.includes(this.search)) {
            return element;
          }
        });
      }
    },
  },
  data() {
    return {
      serviceHistoryList: [],
      filterHistoryList: [],
      search: "",
      temporizationRefresh: 15,
      isLoadingHistory: false,
    };
  },
  methods: {
    async _getTechnicianAccess() {
      await this.authService
        .getAccess(createJsonAccess())
        .then((response) => {
          var sPageURL = response.urlredirect.substring(1);
          var sURLVariables = sPageURL.split("?");
          for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] === "access_token") {
              console.log(sParameterName[1]);
              localStorage.setItem("vega@token", sParameterName[1]);
              this._getURLParameter();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    _getByTechnicianName() {
      return this.serviceHistoryServices
        .getContractByTechnicianName(this.$store.state.technicianLogin)
        .then((response) => {
          this.serviceHistoryList = response;
        });
    },

    _getHistoryLeader(phone){
      return this.serviceHistoryServices.getHistoryleader(phone).then((response) => {
        this.serviceHistoryList = response;
      });
    },

    async _getTechnicianDataByLogin() {
      await this.serviceHistoryServices
        .getDefaultTechnicianDataByLogin(this.$store.state.technicianLogin)
        .then((response) => {
          if (response == "") {
            this.$store.commit("setNumberPhone", "");
          } else {
            const exhistingPhone = localStorage.getItem("leaderPhone");
            this.$store.commit("setNumberPhone", exhistingPhone ? exhistingPhone : response.telefone);
            this.$store.commit("setAccredited", response.credenciada);
            this.$store.commit("setTeam", response.equipe);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    filterServiceHistory() {
      if (this.search === "") {
        this.filterHistoryList = this.serviceHistoryList;
      } else {
        this.filterHistoryList = [];
        this.serviceHistoryList.filter((element) => {
          if (element.contractNumber.includes(this.search)) {
            this.filterHistoryList.push(element);
          }
        });
      }
    },

    loagoutUser() {
      localStorage.removeItem("vega@token");
      localStorage.clear();

      window.location = "/";
    },

    _getURLParameter() {
      let token = localStorage.getItem("vega@token");
      let dados_token = jwt_decode(token);

      this.$store.commit("setContractGlobal", dados_token.Contrato);
      this.$store.commit("setTechnicianLogin", dados_token.LoginTecnico);
      this.$store.commit("setNumeroOS", dados_token.osNumbers);
      this.$store.commit("setAddressCity", dados_token.AddressCity);
      this.$store.commit("setTechnicianName", dados_token.NomeTecnico);
      this.$store.commit("setOsDescription", dados_token.OsDescription);
      this.$store.commit("setEpoName", dados_token.EpoName);
    },
    _refreshMethods() {
      setInterval(() => {
        this._getByTechnicianName();
        this.temporizationRefresh = 15;
      }, 15000);
    },
    _TemporizationRefresh() {
      setInterval(() => {
        this.temporizationRefresh -= 1;
      }, 1000);
    },

    async _listServiceHistoryByRole() {
      const registredLeaderPhone = localStorage.getItem("leaderPhone");

      if(registredLeaderPhone){
        let storePhone = this.$store.state.numberPhone;
        console.log('storePhone', storePhone)
        console.log('registredLeaderPhone', registredLeaderPhone)

        if(storePhone !== registredLeaderPhone){
          this.$store.commit("setNumberPhone", registredLeaderPhone);
          console.log('setou phone no store: ', this.$store.state.numberPhone);
          return await this._getHistoryLeader(registredLeaderPhone);
        } else if(storePhone == registredLeaderPhone){
          console.log('sao iguais')
          localStorage.removeItem("leaderPhone");
          await this._getByTechnicianName();
          return;
        }
      }else{
        return await this._getByTechnicianName();
      }

      // registredLeaderPhone ? 
      // await this._getHistoryLeader(registredLeaderPhone) : await this._getByTechnicianName();
    },
  },

  async mounted() {
    this.isLoadingHistory = true;
   await  this._getTechnicianAccess();
    await this._getTechnicianDataByLogin();
    await this._listServiceHistoryByRole();
    await this._refreshMethods();
    await this._TemporizationRefresh();
    this.isLoadingHistory = false;
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

.header {
  padding: 2% 4%;

  .section-header-description {
    padding: 10% 0% 0% 1%;

    label {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      color: #999999;
    }
  }

  .section-search {
    .icon-tune {
      color: #999999;
    }
  }
}

.content-cards-histories {
  padding: 2% 5%;
}
</style>